import React, { FC, forwardRef, RefAttributes } from 'react';
import { TextInput } from '@trip-ux/components';
import { FieldRenderProps } from 'react-final-form';
import { get, replace, toNumber } from 'lodash';
const regEx = RegExp('\\D', 'g');
const changeValue = (allowZero: boolean, value: number) => (!allowZero && value === 0 ? '' : value);
export const GenericNumberInput: FC<
  FieldRenderProps<string> & RefAttributes<HTMLInputElement> & { ariaLabel?: string; allowZero?: boolean }
> = forwardRef(
  (
    {
      labels,
      ariaLabel,
      input,
      meta,
      required,
      showLabel = false,
      className = '',
      disabled = false,
      id,
      validateOnActive = true,
      allowZero = true,
      type
    },
    ref
  ) => {
    const label = get(labels, input.name, '');
    return (
      <div className={`mb-auto space-between ${className}`}>
        <TextInput
          {...input}
          onChange={e => {
            const value = toNumber(replace(e.target.value, regEx, ''));
            input.onChange(changeValue(allowZero, value));
          }}
          id={id ? id : input.name}
          disabled={disabled}
          type={type ?? 'number'}
          className="my-auto text-input-policy"
          placeholder={label}
          error={(!validateOnActive || !meta.active) && meta.touched && meta.error}
          ref={ref}
          showLabel={showLabel}
          required={required}>
          {showLabel ? label : ariaLabel}
        </TextInput>
      </div>
    );
  }
);
GenericNumberInput.displayName = 'GenericNumberInput';
